import { HttpMethod, Type } from "@/Utils/request/types";
import {
  AppointmentCreatePublicRequest,
  AppointmentReservePublicRequest,
  AvailabilityHeatmapRequest,
  AvailabilityHeatmapResponse,
  PublicAppointment,
  SchedulableResourceType,
  TokenSlot,
} from "@/types/scheduling/schedule";

export default {
  getSlotsForDay: {
    path: "/api/v1/otp/slots/get_slots_for_day/",
    method: HttpMethod.POST,
    TRes: Type<{ results: TokenSlot[] }>(),
    TBody: Type<{
      facility: string;
      resource_type: SchedulableResourceType;
      resource_id: string;
      day: string;
    }>(),
  },
  availabilityStats: {
    path: "/api/v1/otp/slots/availability_stats/",
    method: HttpMethod.POST,
    TRes: Type<AvailabilityHeatmapResponse>(),
    TBody: Type<AvailabilityHeatmapRequest & { facility: string }>(),
  },
  getAppointments: {
    path: "/api/v1/otp/slots/get_appointments/",
    method: HttpMethod.GET,
    TRes: Type<{ results: PublicAppointment[] }>(),
  },
  createAppointment: {
    path: "/api/v1/otp/slots/{id}/create_appointment/",
    method: HttpMethod.POST,
    TRes: Type<PublicAppointment>(),
    TBody: Type<AppointmentCreatePublicRequest>(),
  },
  reserveAppointment: {
    path: "/api/v1/otp/slots/{id}/reserve_appointment/",
    method: HttpMethod.POST,
    TRes: Type<PublicAppointment>(),
    TBody: Type<AppointmentReservePublicRequest>(),
  },
  confirmAppointment: {
    path: "/api/v1/otp/slots/confirm_appointment/",
    method: HttpMethod.POST,
    TRes: Type<PublicAppointment>(),
    TBody: Type<{ appointment: string; patient?: string | null }>(),
  },
  cancelAppointment: {
    path: "/api/v1/otp/slots/cancel_appointment/",
    method: HttpMethod.POST,
    TRes: Type<PublicAppointment>(),
    TBody: Type<{ appointment: string }>(),
  },
  rescheduleAppointment: {
    path: "/api/v1/otp/slots/reschedule_appointment/",
    method: HttpMethod.POST,
    TRes: Type<PublicAppointment>(),
    TBody: Type<{
      appointment: string;
      new_slot: string;
      new_booking_note: string;
      previous_booking_note?: string | null;
    }>(),
  },
} as const;
